export default {
  zh: {
    rulesCoentenTextOne: `1.如果您想要其他规则之外的靓号ID，请联系官方客服；`,
    rulescoenTwo: '2.如果用户连续60天未登录APP或账号违规，平台有权撤回靓号ID；',
    rulescoenThree: '3.如果靓号ID被用户更改或被平台回收，如果当前有用户在使用，则不允许其再次申请更改相同的靓号ID；',
    rulescoenFour: '4.靓号ID兑换有限制次数。如果您需要续订和增加赎回次数，请查看规则；',
    rulescoenFive: '5.如果用户在活动期间涉嫌使用非法方法刷数据，官方有权清除活动数据并取消活动资格;',
    rulescoenSix: '6、本次事件的最终解释权归官方所有，本次事件与苹果无关。股份有限公司',
    domTitle: '靓号ID',
    sixNumTitle: '6个数字',
    fiveNumTitle: '5个数字',
    sevenNumTitle: '7个数字',
    leveTitle: '等级',
    rulesText: '规则',
    selectTip: '输入至少两个最多四个你偏好的数字',
    nickname: '昵称',
    wealthlevel: '财富等级',
    Redeemabletimes: '可兑换次数',
    Next: '下一步',
    tipInselect: '提示：随后生成的靓号ID将基于您此时选择的数字',
    tipInpageOne: '本活动的最终解释权属于Yayya',
    tipInpageTwo: '此活动与APPLE无关',
    notwoFive: '财富等级>=25级才可以兑换靓号',
    tiemZero: '当前可兑换靓号次数为0',
    fistNumZreo: '靓号ID的首位不能为0',
    notFivety: '需要财富等级>=50级才能兑换同1数字的靓号',
    notFourFive: '需要财富等级>=45级才能兑换2个不同数字的靓号',
    Choosepretty: '选择靓号',
    showYouCanuse: '仅展示您可使用的靓号',
    Confirm: '确定',
    Cancel: '取消',
    sureYourChoose: '确定兑换靓号ID:',
    hadUse: '该靓号已被其他用户使用，请选择其他靓号',
    useOk: '兑换靓号成功',
    useError: '兑换靓号失败，请稍后重试',
    useEmpty: '已经没有您可使用的靓号了~',
    bigFour: '最多选择4个不同的数字',
  },
  ar: {
    rulesCoentenTextOne: `1. إذا كنت تريد ايدي مميز خارج القواعد ، فيرجى الاتصال بخدمة العملاء الرسمية؛`,
    rulescoenTwo:
      '2. إذا لم يسجل المستخدم الدخول إلى التطبيق لمدة 60 يومًا متتاليًا أو كان الحساب ينتهك القواعد، فيحق للمنصة سحب ايدي مميز؛',
    rulescoenThree:
      '3. إذا قام المستخدم بتغيير ايدي مميز أو يسحبه المنصة، وإذا كان المستخدم يستخدمه حاليًا، فلن يُسمح له/لها بالتقدم لتغيير نفس ايدي مميز مرة أخرى؛',
    rulescoenFour:
      '4. هناك حد لعدد المرات التي يمكنك فيها استرداد ايدي مميز. إذا كنت بحاجة إلى تجديد وزيادة عدد الاسترداد، يرجى التحقق من القواعد؛',
    rulescoenFive:
      '5. في حالة الاشتباه في قيام المستخدم باستخدام طرق غير قانونية لزيادة البيانات أثناء الحدث، يحق للمسؤول مسح بيانات الحدث واستبعاد الحدث.',
    rulescoenSix: '6. حق التفسير النهائي لهذه الحادثة يعود للرسمي، ولا علاقة لهذه الحادثة بشركة أبل. المحدودة',
    domTitle: 'ايدي مميز',
    sixNumTitle: '6 أرقام',
    fiveNumTitle: '5 أرقام',
    sevenNumTitle: '7 أرقام',
    leveTitle: 'مستوى',
    rulesText: 'قواعد',
    selectTip: 'أدخل رقمين على الأقل وأربعة على الأكثر تفضله',
    nickname: 'الاسم',
    wealthlevel: 'مستوى الثروة',
    Redeemabletimes: 'مرة الاسترداد المتاحة',
    Next: 'الخطوة التالية',
    tipInselect: 'نصيحة: سيعتمد ايدي مميز الذي تم إنشاؤه لاحقًا على الأرقام التي تحدده في هذا الوقت',
    tipInpageOne: 'الحق النهائي في تفسير هذا النشاط يعود إلى Yayya',
    tipInpageTwo: 'هذا النشاط ليس له علاقة بشركة APPLE',
    notwoFive: 'فقط أولئك الذين لديهم مستوى ثروة ≥ 25 يمكنهم استرداد الايدي المميز',
    tiemZero: 'مرة استرداد الايدي المميز هو 0',
    fistNumZreo: 'لا يمكن أن يكون الرقم الأول من الايدي المميز 0',
    notFivety: ' بحاجة إلى مستوى الثروة ≥ 50 لاسترداد الايدي المميز بنفس الرقم',
    notFourFive: ' بحاجة إلى مستوى الثروة ≥ 45 لاسترداد الايدي المميز ب 2 رقمين مختلفة',
    Choosepretty: 'اختر ايدي  مميز',
    showYouCanuse: 'اعرض فقط الايدي المميز التي يمكنك استخدامها',
    Confirm: 'تأكيد',
    Cancel: 'إلغاء',
    sureYourChoose: 'هل تؤكد من استرداد الايدي المميز:',
    hadUse: 'لقد تم استخدام هذا الايدي المميز من قبل مستخدمين آخرين، يرجى اختيار ايدي مميز آخر',
    useOk: 'استراداد الايدي المميز نجاحا',
    useError: 'استراداد الايدي المميز فشلا، يرجو محاولة لاحقا',
    useEmpty: 'لا توجد ايدي مميز أكثر  متاحة لك ~',
    bigFour: 'اختر ما يصل إلى 4 أرقام مختلفة',
  },
  tr: {
    rulesCoentenTextOne: `1. Kuralların dışında başka Özel ID istiyorsanız, lütfen resmi müşteri hizmetleriyle iletişime geçin;`,
    rulescoenTwo:
      "2. Kullanıcının art arda 60 gün boyunca Uygulama' ya giriş yapmaması veya hesabın kuralları ihlal etmesi durumunda platformun Özel ID'yi geri çekme hakkı vardır;",
    rulescoenThree:
      "3. Özel ID'nin kullanıcı tarafından değiştirilmesi veya platform tarafından geri alınması durumunda, halihazırda onu kullanan bir kullanıcı varsa, aynı Özel ID'yi tekrar değiştirmek için başvuruda bulunamaz;",
    rulescoenFour:
      '4. Özel ID ödemeleri için sınırlı süreler vardır. Eğer yenilemeniz ve kullanım sayınızı artırmanız gerekiyorsa lütfen kuralları kontrol ediniz;',
    rulescoenFive:
      '5. Bir kullanıcının etkinlik sırasında veriler için yasa dışı yöntemler kullandığından şüpheleniliyorsa, yetkili etkinlik verilerini sıfırlama ve etkinlik kalifikasyonunu iptal etme hakkına sahiptir.',
    rulescoenSix:
      '6. Bu etkinliğin nihai yorumlama hakkı yetkiliye ait olup, bu etkinliğin Apple.Inc ile hiçbir ilgisi yoktur.',
    domTitle: 'Özel ID',
    sixNumTitle: '6 Sayı',
    fiveNumTitle: '5 Sayı',
    sevenNumTitle: '7 Sayı',
    leveTitle: 'Level',
    rulesText: 'Kural',
    selectTip: 'En az iki en fazla dört tercih ettiğiniz rakamı girin',
    nickname: 'Takma Ad',
    wealthlevel: 'Servet Seviyesi',
    Redeemabletimes: `Kullanılabilir Zamanlar`,
    Next: 'İleri',
    tipInselect: 'İpuçları: Daha sonra oluşturulan Özel ID, o anda seçtiğiniz numaraya/numaralara dayalı olacaktır.',
    tipInpageOne: "Bu etkinliğin son yorumlama hakkı Yayya'e aittir.",
    tipInpageTwo: 'Bu etkinliğin APPLE ile hiçbir ilgisi yoktur',
    notwoFive: 'Özel bir ID ile takas etmek için servet seviyesi>=25 gereklidir',
    tiemZero: "Özel bir ID'i şu anda kaç kez kullanabileceğiniz 0'dır",
    fistNumZreo: "Özel ID'nin ilk rakamı 0 olamaz",
    notFivety: 'Aynı sayıda Özel ID takas etmek için servet seviyesi>=50 gereklidir',
    notFourFive: 'İki farklı Özel ID kullanmak için servet seviyesi>=45 gereklidir',
    Choosepretty: 'Özel ID seçin',
    showYouCanuse: 'Yalnızca kullanabileceğiniz Özel ID görüntüleyin',
    Confirm: 'Onayla',
    Cancel: 'İptal',
    sureYourChoose: 'Özel ID kullanmayı onaylıyor musunuz:',
    hadUse: 'Bu Özel ID başka bir kullanıcı tarafından kullanılıyor. Lütfen başka bir Özel ID seçin.',
    useOk: 'Özel ID başarıyla kullanıldı.',
    useError: 'Özel ID kullanımı başarısız oldu, lütfen daha sonra tekrar deneyin',
    useEmpty: 'Kullanabileceğiniz Özel ID Yok',
    bigFour: 'En fazla 4 farklı numara seçin',
  },
  en: {
    rulesCoentenTextOne: `1. If you want other pretty ID outside the rules, please contact official customer service;`,
    rulescoenTwo:
      '2. If the user does not log in to the APP for 60 consecutive days or the account violates the rules, the platform has the right to withdraw the pretty ID;',
    rulescoenThree:
      '3. If the pretty ID is changed by the user or recycled by the platform, if there is a user currently using it, he or she is not allowed to apply to change the same pretty ID again;',
    rulescoenFour:
      '4. There are limits times for pretty ID redemptions. If you need to renew and increase the number of redemptions, please check the rules;',
    rulescoenFive:
      '5. If a user is suspected of using illegal methods to brush data during the event, the official has the right to clear the event data and cancel the event qualification',
    rulescoenSix:
      '6. The final interpretation right of this event belongs to the official, and this event has nothing to do with Apple.Inc.',
    domTitle: 'Pretty ID',
    sixNumTitle: '6 numbers',
    fiveNumTitle: '5 numbers',
    sevenNumTitle: '7 numbers',
    leveTitle: 'Level',
    rulesText: 'Rules',
    selectTip: 'Enter at least two at most four you prefer number',
    nickname: 'Nickname',
    wealthlevel: 'Wealth level',
    Redeemabletimes: 'Redeemable times',
    Next: 'Next',
    tipInselect:
      'Tips: The pretty ID generated subsequently will be based on the number(s) you have selected at this time',
    tipInpageOne: 'The final interpretation right of this activity belongs to Yayya',
    tipInpageTwo: 'This activity has nothing to do with APPLE',
    notwoFive: 'Wealth level>=25 is required to exchange for a pretty ID',
    tiemZero: 'The current number of times you can redeem a pretty ID is 0',
    fistNumZreo: 'The first digit of the pretty ID can not be 0',
    notFivety: 'Wealth level>=50 is required to exchange for the same number of pretty ID',
    notFourFive: 'Wealth level>=45 is required to redeem two different numbers of pretty ID',
    Choosepretty: 'Choose a pretty ID',
    showYouCanuse: 'Only display the pretty ID that you can use',
    Confirm: 'Confirm',
    Cancel: 'Cancel',
    sureYourChoose: 'Confirm to redeem the pretty ID:',
    hadUse: 'This pretty ID has been used by another user. Please select another pretty ID.',
    useOk: 'Redeemed the pretty ID successfully ',
    useError: 'Redemption the pretty ID failed,please try again later',
    useEmpty: 'There are no more pretty ID  available for you to use',
    bigFour: 'Select up to 4 different numbers',
  },
  pt: {
    rulesCoentenTextOne: `1. Se você quiser um ID bonito fora das regras, entre em contato com o suporte ao cliente oficial;`,
    rulescoenTwo:
      '2. Se o usuário não fizer login no APP por 60 dias consecutivos ou se a conta violar as regras, a plataforma tem o direito de retirar o ID bonito;',
    rulescoenThree:
      '3. Se o ID bonito for alterado pelo usuário ou reciclado pela plataforma, se houver um usuário atualmente usando, ele ou ela não poderá aplicar para alterar o mesmo ID bonito novamente;',
    rulescoenFour:
      '4. Existem limites para o número de resgates do ID bonito. Se você precisar renovar e aumentar o número de resgates, consulte as regras;',
    rulescoenFive:
      '5. Se um usuário for suspeito de usar métodos ilegais para manipular dados durante o evento, a oficial tem o direito de limpar os dados do evento e cancelar a qualificação do evento;',
    rulescoenSix:
      '6. O direito de interpretação final deste evento pertence ao oficial, e este evento não tem relação com a Apple Inc.',
    domTitle: 'ID Bonito',
    sixNumTitle: '6 números',
    fiveNumTitle: '5 números',
    sevenNumTitle: '7 números',
    leveTitle: 'Nível',
    rulesText: 'Regras',
    selectTip: 'Digite pelo menos dois no máximo quatro números que você prefere',
    nickname: 'Apelido',
    wealthlevel: 'Nível de riqueza',
    Redeemabletimes: 'Número de resgates',
    Next: 'Próximo',
    tipInselect: 'Dica: O ID bonito gerado posteriormente será baseado no número(s) que você selecionou neste momento',
    tipInpageOne: 'O direito de interpretação final desta atividade pertence à Yayya',
    tipInpageTwo: 'Este evento não tem relação com a APPLE',
    notwoFive: 'Nível de riqueza >= 25 é necessário para trocar por um ID bonito',
    tiemZero: 'O número atual de vezes que você pode resgatar um ID bonito é 0',
    fistNumZreo: 'O primeiro dígito do ID bonito não pode ser 0',
    notFivety: 'Nível de riqueza >= 50 é necessário para trocar pelo mesmo número de ID bonito',
    notFourFive: 'Nível de riqueza >= 45 é necessário para resgatar dois números diferentes de ID bonito',
    Choosepretty: 'Escolha um ID bonito',
    showYouCanuse: 'Exibir apenas os IDs bonitos que você pode usar',
    Confirm: 'Confirmar',
    Cancel: 'Cancelar',
    sureYourChoose: 'Confirmar resgatar o ID bonito:',
    hadUse: 'Este ID bonito já foi usado por outro usuário. Por favor, selecione outro ID bonito.',
    useOk: 'ID bonito resgatado com sucesso',
    useError: 'Falha ao resgatar o ID bonito, por favor tente novamente mais tarde',
    useEmpty: 'Não há mais IDs bonitos disponíveis para você usar',
    bigFour: 'Selecione até 4 números diferentes',
  },
  id: {
    rulesCoentenTextOne: `1. Jika Anda ingin ID cantik lain di luar aturan, harap hubungi layanan pelanggan resmi;`,
    rulescoenTwo:
      '2. Jika pengguna tidak login ke APLIKASI selama 60 hari berturut-turut atau akun melanggar aturan, platform berhak menarik ID cantik;',
    rulescoenThree:
      '3. Jika ID cantik diubah oleh pengguna atau didaur ulang oleh platform, jika ada pengguna yang saat ini menggunakannya, dia tidak diperbolehkan untuk mengajukan permohonan untuk mengubah ID cantik yang sama lagi;',
    rulescoenFour:
      '4. Ada batasan jumlah penukaran ID cantik. Jika Anda perlu memperbarui dan menambah jumlah penukaran, harap periksa aturan;',
    rulescoenFive:
      '5. Jika seorang pengguna diduga menggunakan metode ilegal untuk memanipulasi data selama acara, pihak resmi berhak menghapus data acara dan membatalkan kualifikasi acara',
    rulescoenSix:
      '6. Hak penafsiran akhir dari acara ini adalah milik pihak resmi, dan acara ini tidak ada hubungannya dengan Apple.Inc.',
    domTitle: 'ID Cantik',
    sixNumTitle: '6 angka',
    fiveNumTitle: '5 angka',
    sevenNumTitle: '7 angka',
    leveTitle: 'Level',
    rulesText: 'Aturan',
    selectTip: 'Masukkan setidaknya dua paling banyak empat angka yang Anda sukai',
    nickname: 'Nama panggilan',
    wealthlevel: 'Level kekayaan',
    Redeemabletimes: 'Jumlah penukaran',
    Next: 'Selanjutnya',
    tipInselect:
      'Tips: ID cantik yang dihasilkan selanjutnya akan didasarkan pada angka yang telah Anda pilih saat ini',
    tipInpageOne: 'Hak penafsiran akhir dari aktivitas ini milik Yayya',
    tipInpageTwo: 'Aktivitas ini tidak ada hubungannya dengan APPLE',
    notwoFive: 'Level kekayaan>=25 diperlukan untuk menukar ID cantik',
    tiemZero: 'Jumlah penukaran ID cantik saat ini adalah 0',
    fistNumZreo: 'Digit pertama dari ID cantik tidak boleh 0',
    notFivety: 'Level kekayaan>=50 diperlukan untuk menukar ID cantik dengan jumlah yang sama',
    notFourFive: 'Level kekayaan>=45 diperlukan untuk menukar dua ID cantik dengan angka yang berbeda',
    Choosepretty: 'Pilih ID cantik',
    showYouCanuse: 'Hanya tampilkan ID cantik yang dapat Anda gunakan',
    Confirm: 'Konfirmasi',
    Cancel: 'Batal',
    sureYourChoose: 'Konfirmasi untuk menukarkan ID cantik:',
    hadUse: 'ID cantik ini telah digunakan oleh pengguna lain. Harap pilih ID cantik lain.',
    useOk: 'ID cantik berhasil ditukarkan',
    useError: 'Penukaran ID cantik gagal, harap coba lagi nanti',
    useEmpty: 'Tidak ada lagi ID cantik yang tersedia untuk Anda gunakan',
    bigFour: 'Pilih hingga 4 angka yang berbeda',
  },
  uz: {
    rulesCoentenTextOne:
      "1. Agar siz qoidalardan tashqari boshqa ajoyib aidini xohlasangiz, rasmiy vakil bilan bog'laning;",
    rulescoenTwo:
      '2. Agar foydalanuvchi 60 kun ketma-ket dasturga kirmasa yoki hisob qoidalarni buzsa, platforma salqin idini qaytarib olish huquqiga ega;',
    rulescoenThree:
      "3. Agar Cool IDE foydalanuvchi tomonidan o'zgartirilsa yoki platforma tomonidan qayta ishlangan bo'lsa va boshqa foydalanuvchilar hozirda ushbu Cool IDE-dan foydalanayotgan bo'lsa, ushbu IDE-ni olish uchun so'rov yuborish mumkin emas;",
    rulescoenFour:
      "4. Salqin IDE-ni necha marta olish mumkinligi haqida cheklov mavjud. Agar siz qabul qilish vaqtini uzaytirishingiz va ko'paytirishingiz kerak bo'lsa, qoidalarni ko'rib chiqing;",
    rulescoenFive:
      "5. Agar foydalanuvchi tadbir davomida firibgar yoki noqonuniy usullardan foydalansa, biz tadbir ma'lumotlarini o'chirish va tadbirni diskvalifikatsiya qilish huquqiga egamiz",
    rulescoenSix:
      "6. Ushbu tadbirni yakuniy talqin qilish huquqi Yayya-ga tegishli va bu tadbir Apple bilan hech qanday aloqasi yo'q.Inc.",
    domTitle: 'Ajoyib aydi',
    sixNumTitle: '6 ta raqam',
    fiveNumTitle: '5 ta raqam',
    sevenNumTitle: '7 ta raqam',
    leveTitle: 'Daraja',
    rulesText: 'Qoidalar',
    selectTip: "Kamida ikkita, ko'pi bilan to'rtta afzal ko'rgan raqamingizni kiriting",
    nickname: 'Nik',
    wealthlevel: 'Boylik darajasi',
    Redeemabletimes: 'Mavjud almashinuvlar soni',
    Next: 'Keyingi',
    tipInselect: 'Maslahatlar: keyinchalik yaratilgan salqin aydi siz tanlagan raqamlarga asoslanadi.',
    tipInpageOne: 'Ushbu harakatni talqin qilishning yakuniy huquqi Yayyaga tegishli',
    tipInpageTwo: "Ushbu tadbir APPLE bilan hech qanday aloqasi yo'q",
    notwoFive: 'Salqin aydi bilan savdo qilish uchun boylik darajasi>=25 talab qilinadi',
    tiemZero: "Salqin aydi olish uchun mavjud bo'lgan vaqtlar soni 0 ga teng",
    fistNumZreo: "Salqin Idining birinchi raqami 0 ga teng bo'lishi mumkin emas",
    notFivety: '1-raqamli salqin aydi bilan savdo qilish uchun boylik darajasi > =50 talab qilinadi.',
    notFourFive: "2 xil raqamga ega bo'lgan salqin aydi bilan savdo qilish uchun boylik darajasi > =45 talab qilinadi",
    Choosepretty: 'Salqin aydi tanlang',
    showYouCanuse: "Faqat mavjud salqin aydilarni ko'rsating",
    Confirm: 'Tasdiqlash',
    Cancel: 'Bekor qilish',
    sureYourChoose: 'Salqin Idining faollashuvini tasdiqlang: ',
    hadUse: 'Bu ajoyib Aidi boshqa foydalanuvchi tomonidan ishlatilgan. Iltimos, boshqa ajoyib idini tanlang.',
    useOk: "Ajoyib Aidi almashinuvi muvaffaqiyatli bo'ldi",
    useError: "Salqin aydi almashish xatosi, keyinroq qayta urinib ko'ring",
    useEmpty: 'Almashish uchun ajoyib Aidi mavjud emas',
    bigFour: '4 tagacha turli raqamlarni tanlang',
  },
  ru: {
    rulesCoentenTextOne:
      '1. Если вам нужен другой крутой айди, выходящий за рамки правил, свяжитесь с официальным представителем;',
    rulescoenTwo:
      '2. Если пользователь не входит в приложение в течение 60 дней подряд или аккаунт нарушает правила, платформа имеет право отозвать крутой айди;',
    rulescoenThree:
      '3. Если крутой айди изменен пользователем или переработан платформой, и другие пользователи в настоящее время используют этот крутой айди, запрос на получение этого айди невозможен；',
    rulescoenFour:
      '4. Существует ограничение на количество раз, когда можно получить крутой айди. Если вам необходимо продлить и увеличить количество раз получения, ознакомьтесь с правилами；',
    rulescoenFive:
      '5. Если пользователь использует мошеннические или незаконные методы во время мероприятия, мы имеем право удалить данные о мероприятии и дисквалифицировать мероприятие',
    rulescoenSix:
      '6. Право на окончательную интерпретацию данного мероприятия принадлежит Yayya, и это мероприятие не имеет никакого отношения к Apple.Inc.',
    domTitle: 'Крутой айди',
    sixNumTitle: '6 цифр',
    fiveNumTitle: '5 цифр',
    sevenNumTitle: '7 цифр',
    leveTitle: 'Уровень',
    rulesText: 'Правила',
    selectTip: 'Введите не менее двух и не более четырех предпочитаемых номеров',
    nickname: 'Ник',
    wealthlevel: 'Уровень богатства',
    Redeemabletimes: 'Количество доступных обменов',
    Next: 'Следующий',
    tipInselect:
      'Советы: крутой айди, сгенерированный впоследствии, будет основан на номерах, которые вы выбрали на данный момент.',
    tipInpageOne: 'Окончательное право на интерпретацию этого действия принадлежит Yayya',
    tipInpageTwo: 'Это мероприятие не имеет никакого отношения к APPLE',
    notwoFive: 'Для обмена на крутой айди требуется уровень богатства>=25',
    tiemZero: 'Текущее количество раз, которое вы можете  для получения крутого айди, равно 0',
    fistNumZreo: 'Первая цифра крутого айди не может быть равна 0',
    notFivety: 'Для обмена на крутой айди с 1  номером требуется уровень богатства>=50.',
    notFourFive: 'Для обмена на крутой айди с 2 разными номерами требуется уровень богатства>=45',
    Choosepretty: 'Выберите крутой айди',
    showYouCanuse: 'Показать только доступные крутые айди',
    Confirm: 'Подтвердить',
    Cancel: 'Отмена',
    sureYourChoose: 'Подтвердите активацию крутого айди: ',
    hadUse: 'Этот крутой айди использовался другим пользователем. Пожалуйста, выберите другой крутой айди.',
    useOk: 'Обмен крутого айди успешен',
    useError: 'Ошибка обмена крутого айди, попробуйте снова позже',
    useEmpty: 'Нет доступных  крутых айди для обмена',
    bigFour: 'Выберите до 4 различных номеров',
  },
  fa: {
    rulesCoentenTextOne:
      '1. اگر می‌خواهید یک شناسه زیبا خارج از قوانین داشته باشید، لطفاً با پشتیبانی رسمی تماس بگیرید;',
    rulescoenTwo:
      '2. اگر کاربر به مدت 60 روز متوالی وارد اپلیکیشن نشود یا حساب کاربری قوانین را نقض کند، پلتفرم حق دارد شناسه زیبا را پس بگیرد;',
    rulescoenThree:
      '3. اگر شناسه زیبا توسط کاربر تغییر داده شود یا توسط پلتفرم بازیافت شود، اگر در حال حاضر توسط کاربری استفاده شود، او مجاز به درخواست تغییر همان شناسه زیبا نخواهد بود;',
    rulescoenFour:
      '4. تعداد دفعاتی که می‌توان شناسه زیبا را بازخرید کرد محدود است. اگر نیاز به تمدید و افزایش تعداد بازخریدها دارید، لطفاً قوانین را بررسی کنید;',
    rulescoenFive:
      '5. اگر یک کاربر مشکوک به استفاده از روش‌های غیرقانونی برای دستکاری داده‌ها در طول رویداد باشد، مسئولین حق دارند داده‌های رویداد را پاک کرده و واجد شرایط بودن برای رویداد را لغو کنند',
    rulescoenSix: '6. حق تفسیر نهایی این رویداد متعلق به مسئولین است و این رویداد هیچ ارتباطی با Apple.Inc. ندارد.',
    domTitle: 'شناسه زیبا',
    sixNumTitle: '6 رقم',
    fiveNumTitle: '5 رقم',
    sevenNumTitle: '7 رقم',
    leveTitle: 'سطح',
    rulesText: 'قوانین',
    selectTip: 'حداقل دو و حداکثر چهار عدد مورد علاقه خود را وارد کنید',
    nickname: 'نام مستعار',
    wealthlevel: 'سطح ثروت',
    Redeemabletimes: 'تعداد بازخریدها',
    Next: 'بعدی',
    tipInselect: 'نکته: شناسه زیبا که بعداً تولید می‌شود بر اساس شماره‌هایی است که در این زمان انتخاب کرده‌اید',
    tipInpageOne: 'حق تفسیر نهایی این فعالیت متعلق به Yayya است',
    tipInpageTwo: 'این فعالیت هیچ ارتباطی با APPLE ندارد',
    notwoFive: 'برای بازخرید شناسه زیبا سطح ثروت >=25 لازم است',
    tiemZero: 'تعداد دفعاتی که می‌توانید شناسه زیبا را بازخرید کنید برابر با 0 است',
    fistNumZreo: 'اولین رقم شناسه زیبا نباید 0 باشد',
    notFivety: 'برای بازخرید شناسه زیبا با همان شماره سطح ثروت >=50 لازم است',
    notFourFive: 'برای بازخرید دو شناسه زیبا با شماره‌های مختلف سطح ثروت >=45 لازم است',
    Choosepretty: 'شناسه زیبا را انتخاب کنید',
    showYouCanuse: 'فقط شناسه زیباهایی که می‌توانید استفاده کنید را نمایش دهید',
    Confirm: 'تایید',
    Cancel: 'لغو',
    sureYourChoose: 'برای بازخرید شناسه زیبا تایید کنید:',
    hadUse: 'این شناسه زیبا قبلاً توسط کاربر دیگری استفاده شده است. لطفاً شناسه زیبا دیگری انتخاب کنید.',
    useOk: 'بازخرید شناسه زیبا با موفقیت انجام شد',
    useError: 'بازخرید شناسه زیبا ناموفق بود، لطفاً بعداً دوباره تلاش کنید',
    useEmpty: 'هیچ شناسه زیبا دیگری برای استفاده در دسترس نیست',
    bigFour: 'محدود به انتخاب حداکثر 4 شماره مختلف',
  },
  ur: {
    rulesCoentenTextOne:
      '1. اگر آپ قواعد سے ہٹ کر کوئی خوبصورت ID چاہتے ہیں، تو براہ کرم سرکاری کسٹمر سروس سے رابطہ کریں؛',
    rulescoenTwo:
      '2. اگر صارف 60 دن تک مسلسل ایپ میں لاگ ان نہیں کرتا یا اکاؤنٹ قواعد کی خلاف ورزی کرتا ہے، تو پلیٹ فارم کو خوبصورت ID واپس لینے کا حق حاصل ہے؛',
    rulescoenThree:
      '3. اگر خوبصورت ID صارف کے ذریعہ تبدیل کی گئی ہو یا پلیٹ فارم کے ذریعہ ری سائیکل کی گئی ہو، اور اگر کوئی صارف اس وقت اسے استعمال کر رہا ہو، تو اسے اسی خوبصورت ID کو دوبارہ تبدیل کرنے کی درخواست دینے کی اجازت نہیں ہوگی؛',
    rulescoenFour:
      '4. خوبصورت ID کے تبادلوں کی محدود تعداد ہے۔ اگر آپ کو تجدید کرنے یا تبادلوں کی تعداد بڑھانے کی ضرورت ہو، تو براہ کرم قواعد چیک کریں؛',
    rulescoenFive:
      '5. اگر کسی صارف پر ایونٹ کے دوران غیر قانونی طریقوں سے ڈیٹا بنانے کا شبہ ہو، تو سرکاری طور پر ایونٹ ڈیٹا صاف کرنے اور ایونٹ کی اہلیت منسوخ کرنے کا حق محفوظ ہے',
    rulescoenSix:
      '6. اس ایونٹ کی حتمی تشریح کا حق سرکاری طور پر محفوظ ہے، اور اس ایونٹ کا ایپل انکارپوریشن سے کوئی تعلق نہیں ہے۔',
    domTitle: 'خوبصورت ID',
    sixNumTitle: '6 ہندسے',
    fiveNumTitle: '5 ہندسے',
    sevenNumTitle: '7 ہندسے',
    leveTitle: 'لیول',
    rulesText: 'قواعد',
    selectTip: 'کم از کم دو اور زیادہ سے زیادہ چار اپنی پسندیدہ تعداد درج کریں',
    nickname: 'عرفیت',
    wealthlevel: 'دولت کا لیول',
    Redeemabletimes: 'تبادلہ کے قابل اوقات',
    Next: 'اگلا',
    tipInselect: 'نوٹ: بعد میں بننے والی خوبصورت ID آپ کے اس وقت منتخب کردہ ہندسوں پر مبنی ہوگی',
    tipInpageOne: 'اس سرگرمی کی حتمی تشریح کا حق Yayya کے پاس ہے',
    tipInpageTwo: 'اس سرگرمی کا ایپل سے کوئی تعلق نہیں ہے',
    notwoFive: 'خوبصورت ID کے تبادلے کے لیے دولت کا لیول >=25 ہونا ضروری ہے',
    tiemZero: 'آپ کے پاس خوبصورت ID کے تبادلے کے قابل اوقات کی موجودہ تعداد 0 ہے',
    fistNumZreo: 'خوبصورت ID کا پہلا ہندسہ 0 نہیں ہو سکتا',
    notFivety: 'ایک ہی تعداد میں خوبصورت ID کے تبادلے کے لیے دولت کا لیول >=50 ہونا ضروری ہے',
    notFourFive: 'دو مختلف تعداد میں خوبصورت ID کے تبادلے کے لیے دولت کا لیول >=45 ہونا ضروری ہے',
    Choosepretty: 'ایک خوبصورت ID منتخب کریں',
    showYouCanuse: 'صرف وہ خوبصورت ID دکھائیں جو آپ استعمال کر سکتے ہیں',
    Confirm: 'تصدیق کریں',
    Cancel: 'منسوخ کریں',
    sureYourChoose: 'خوبصورت ID کے تبادلے کی تصدیق کریں:',
    hadUse:
      'یہ خوبصورت ID پہلے ہی کسی دوسرے صارف کے ذریعہ استعمال کی جا چکی ہے۔ براہ کرم کوئی دوسری خوبصورت ID منتخب کریں۔',
    useOk: 'خوبصورت ID کامیابی سے تبدیل کر دی گئی',
    useError: 'خوبصورت ID تبدیل کرنے میں ناکامی، براہ کرم بعد میں دوبارہ کوشش کریں',
    useEmpty: 'آپ کے استعمال کے لیے کوئی اور خوبصورت ID دستیاب نہیں ہے',
    bigFour: 'زیادہ سے زیادہ 4 مختلف ہندسے منتخب کریں',
  },
}



// WEBPACK FOOTER //
// src/pages/app/duid/lang.js